<template>
<div class="chapter">
<div class="inner_page">
<p class="C884"><strong><span id="page_v">CONTENTS</span></strong></p>
<p class="C941"><img alt="" src="html/images/Image_6_0.png"/></p>
<p class="C891"><em><a href="#/html/05_List_of#page_vii">List of Illustrations</a></em></p>
<p class="C883"><em><a href="#/html/06_Acknowle#page_xi">Acknowledgments</a></em></p>
<p class="C883"><a href="#/html/07_Introduc#page_1">Introduction</a></p>
<p class="C939"><strong><a href="#/html/08_PART_ONE#page_9">PART ONE: MAPPING THE PAST</a></strong></p>
<p class="C940-1"><a href="#/html/09_1__The_G#page_11">1. The Graphic Foundations of American History</a></p>
<p class="C941"><span href="#/html/10_2__Captu#page_41" title="Link target outside of Sample">2. Capturing the Past through Maps</span></p>
<p class="C939"><strong><span href="#/html/11_PART_TWO#page_77" title="Link target outside of Sample">PART TWO: MAPPING THE PRESENT</span></strong></p>
<p class="C940-1"><span href="#/html/12_3__Disea#page_79" title="Link target outside of Sample">3. Disease, Expansion, and the Rise of Environmental Mapping</span></p>
<p class="C941"><span href="#/html/13_4__Slave#page_119" title="Link target outside of Sample">4. Slavery and the Origin of Statistical Cartography</span></p>
<p class="C941"><span href="#/html/14_5__The_C#page_157" title="Link target outside of Sample">5. The Cartographic Consolidation of America</span></p>
<p class="C940"><span href="#/html/15_Conclusi#page_197" title="Link target outside of Sample">Conclusion</span></p>
<p class="C941-1"><em><span href="#/html/16_Notes#page_203" title="Link target outside of Sample">Notes</span></em></p>
<p class="C883"><em><span href="#/html/17_Index#page_237" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?677a5db5